import React, { useEffect, useRef, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked } from '@coreui/icons'
import authen from '../../../models/authen'
import InputPassword from 'src/components/Input/InputPassword'
import Captcha from 'src/components/common/Captcha'

var token = null
const authenModel = new authen()

const ResetPassword = () => {

  const [password, setPassword] = useState('')
  const [password_confirm, setPasswordConfirm] = useState('')
  const captcha = useRef(null)

  useEffect(() => {
    const params = new URLSearchParams(window.location.href.split('?')[1]);
    token = params.get('token')
  }, [])

  const resetPass = () => {
    if (password !== password_confirm) {
      window.alert("Password not match", 'warning')
      return
    }
    let captchaData = captcha.current.getData()
    authenModel.resetPass(token, password, captchaData).then(res => {
      if (res) {
        window.location.href = '/distribution/#/login?error=Login by your new password&level=success'
        window.location.reload()
      }else{
        captcha.current.getCaptcha()
      }
    })
  }

  return (
    <div className="bg-body-tertiary min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={8}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm onSubmit={(e) => {
                    e.preventDefault();
                    resetPass()
                  }}>
                    <h1>Reset Password</h1>
                    <p className="text-body-secondary">Reset your password</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <div style={{ flexGrow: 1 }}>
                        <InputPassword
                          tabIndex={1}
                          style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, padding: 5 }}
                          name='password'
                          value={password}
                          Direct={true}
                          OnChange={(e) => setPassword(e)}
                          className='input'
                          type="password"
                          placeholder="Password"
                        // autoComplete="current-password"
                        /></div>
                    </CInputGroup>
                    <CInputGroup>
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <div style={{ flexGrow: 1 }}>
                        <InputPassword
                          tabIndex={2}
                          style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, padding: 5 }}
                          name='password_confirm'
                          value={password_confirm}
                          Direct={true}
                          OnChange={(e) => setPasswordConfirm(e)}
                          className='input'
                          type="password"
                          placeholder="Password confirm"
                        // autoComplete="current-password"
                        /></div>
                    </CInputGroup>

                    <CRow className='mt-4'>
                      <CCol xs={6}>
                        <CButton tabIndex={4} color="primary" className="px-4"
                          type='submit'
                        >
                          Reset
                        </CButton>
                      </CCol>
                      <CCol xs={6} className="text-right">
                        <Captcha tabIndex={3} ref={captcha}></Captcha>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>

            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default ResetPassword
